export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14943.07016110.jpg";